import component from '../component';

export default component('MuiInputLabel', {
  defaultProps: {
    shrink: true,
  },
});
